import { render, staticRenderFns } from "./createApprove.vue?vue&type=template&id=fe2889d2&scoped=true"
import script from "./createApprove.vue?vue&type=script&lang=js"
export * from "./createApprove.vue?vue&type=script&lang=js"
import style0 from "./createApprove.vue?vue&type=style&index=0&id=fe2889d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2889d2",
  null
  
)

export default component.exports